module.exports = __webpack_public_path__ + "img/54_19.18196ee1.png";